<template>
    <div>
        <div class="border p-4 rounded-sm">
            <ValidationObserver ref="formModalValidate">
                <b-row>
                    <b-col cols="12">
                        <ValidationProvider name="is_interdisciplinary" rules="" v-slot="{valid, errors}">
                            <b-form-group :label="$t('interdisciplinary')">
                                <yes-no-selectbox
                                    :description="$t('interdisciplinary')"
                                    v-model="formData.is_interdisciplinary"
                                    :validate-error="errors[0]"></yes-no-selectbox>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" v-if="formData.is_interdisciplinary === 'Yes'">
                        <ValidationProvider name="interdisciplinary_note" :rules="formData.is_interdisciplinary === 'Yes' ? 'required' : ''" v-slot="{valid, errors}">
                            <b-form-group>
                                <b-form-input type="text" v-model="formData.interdisciplinary_note"
                                              :state="errors[0] ? false : null"/>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12">
                        <ValidationProvider name="has_experiential_learning" rules="" v-slot="{valid, errors}">
                            <b-form-group :label="$t('experiential_learning')">
                                <yes-no-selectbox
                                    :description="$t('experiential_learning')"
                                    v-model="formData.has_experiential_learning"
                                    :validate-error="errors[0]"></yes-no-selectbox>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" v-if="formData.has_experiential_learning === 'Yes'">
                        <ValidationProvider name="experiential_learning_note" :rules="formData.has_experiential_learning === 'Yes' ? 'required' : ''" v-slot="{valid, errors}">
                            <b-form-group>
                                <b-form-input type="text" v-model="formData.experiential_learning_note"
                                              :state="errors[0] ? false : null"/>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </ValidationObserver>
        </div>
        <div class="d-flex justify-content-center mt-3 mb-3">
            <b-button variant="primary"
                      @click="updateForm"
                      :disabled="formProcess">
                {{ $t('add') }}
            </b-button>
        </div>
    </div>
</template>

<script>
// Components

// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"

// Services
import SectionService from "@/services/SectionService"
import SectionDetailService from "@/services/SectionDetailService";
import qs from "qs";
import YesNoSelectbox from "@/components/interactive-fields/YesNoSelectbox.vue";
import CourseService from "@/services/CourseService";

export default {
    components: {
        YesNoSelectbox,
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        formId: {
            type: Number
        }
    },
    data() {
        return {
            section: {},
            details: {},
            formData: {
                interdisciplinary_note: null,
                is_interdisciplinary: false,
                experiential_learning_note: null,
                has_experiential_learning: false,
            },
            formLoading: false,
            formProcess: false
        }
    },
    created() {
        if (this.formId) {
            this.getCourse(this.formId);
        }
    },
    methods: {
        getCourse(id) {
            this.formLoading = true
            CourseService.get(id)
                .then(response => {
                    this.section = response.data.data;
                    this.formData.is_interdisciplinary = this.section.is_interdisciplinary ? 'Yes' : 'No';
                    this.formData.interdisciplinary_note = this.section.interdisciplinary_note;
                    this.formData.has_experiential_learning = this.section.has_experiential_learning ? 'Yes' : 'No';
                    this.formData.experiential_learning_note = this.section.experiential_learning_note;
                })
                .catch(e => {
                    this.showErrors(e)
                })
        },
        async updateForm() {
            if (this.checkPermission('course_updateinterdisciplinary')) {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;

                    const payload = {
                        ...this.formData,
                        is_interdisciplinary: this.formData.is_interdisciplinary === 'Yes' ? 1 : 0,
                        has_experiential_learning: this.formData.has_experiential_learning === 'Yes' ? 1 : 0,
                    };

                    SectionDetailService.updateInterdisciplinary(this.formId, payload)
                        .then(response => {
                            this.$emit('detailInterdisciplinaryFormSuccess', true);
                            this.$toast.success(this.$t('api.' + response.data.message));
                        })
                        .catch(e => {
                            this.showErrors(e, this.$refs.formModalValidate);
                        })
                        .finally(() => {
                            this.formLoading = false
                        })
                }
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }
        }
    }
}
</script>

